import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Button } from '@mui/material';
import { AccessTime, Cancel, Login } from '@mui/icons-material';

export default function IdleTimeoutModal({ open, remainingSeconds, onStay, onLogout }) {
    const minutes = Math.floor(remainingSeconds / 60);
    const seconds = remainingSeconds % 60;
    const timeStr = minutes > 0
        ? `${minutes}:${String(seconds).padStart(2, '0')}`
        : `${seconds}s`;

    return (
        <Modal
            show={open}
            centered
            backdrop="static"
            keyboard={false}
            data-bs-theme="dark"
            className="idle-timeout-modal"
            backdropClassName="idle-timeout-backdrop"
        >
            <Modal.Header>
                <AccessTime style={{ height: "32px", width: "32px", marginRight: "8px", color: "var(--lm-tx-f5f5f5)" }}/>
                <Modal.Title style={{ color: "var(--lm-tx-f5f5f5)" }}>Session Expiring Soon</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ color: "var(--lm-tx-f5f5f5)" }}>
                <p>You've been inactive. Your session will expire in <b>{timeStr}</b>. Stay logged in?</p>
            </Modal.Body>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button variant="contained" color="error" startIcon={<Cancel/>} onClick={onLogout}
                        style={{ margin: "4px" }}>
                    Log Out
                </Button>
                <Button variant="contained" startIcon={<Login/>} onClick={onStay}
                        style={{ margin: "4px" }} autoFocus>
                    Stay Logged In
                </Button>
            </div>
        </Modal>
    );
}
